




















import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { DateCallLog } from '@/types/call'
import dayjs from 'dayjs'
import { StateChanger } from 'vue-infinite-loading'
import { LocalStorageKeys } from '@/constants/localStorage'

@Component({
  components: {
    CallHistoryDay: () => import('@/components/call/CallHistoryDay.vue'),
    InfiniteLoading: () => import('vue-infinite-loading'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class CallHistory extends Vue {
  $store!: ExStore

  get hasNext() {
    return this.$store.getters['call/hasHistoryNext']
  }

  get callLogs() {
    return this.$store.getters['call/dateCallLogs']
  }

  async beforeCreate() {
    await this.$store.dispatch('call/updateHistory')
  }

  getDateStr(dateLog: DateCallLog) {
    return dayjs(dateLog.date).format('M月D日')
  }

  onNextLoad($state: StateChanger) {
    this.$store.dispatch('call/loadNextHistory').then(() => {
      if (this.hasNext) {
        $state.loaded()
      } else {
        $state.complete()
      }
    })
  }

  created() {
    this.$store.commit('call/setLastCheckedTime', dayjs().unix())
  }
}
